import { observer } from 'mobx-react'
import React from 'react'
import { IArpMedia } from '../../../../../features/arp-registry/ArpMedia'
import Button from '../../../core/Button/Button'
import { IconButton } from '../../../core/Components'
import FavoriteButton from '../../../core/FavoriteButton'
import { DotsVertical, PlusIcon } from '../../../core/icons'
import { MediaTypes, MediaTypesType, segmentTrackRemix } from '../../../core/Utils'
import { Spinner, useRemix } from './utils'

const ActionsColumn: React.FC<{
  song?: IArpMedia
  isHovered?: boolean
  isDisabled?: boolean
  songLengthFormatted?: string
  handleMore: () => void
}> = ({ song, isHovered, isDisabled, songLengthFormatted, handleMore }) => {
  const { remixSong, status } = useRemix()

  return (
    <>
      <Button
        disabled={isDisabled}
        rounded
        type={'outlined'}
        css={{
          paddingLeft: '8px',
          cursor: isDisabled ? 'not-allowed' : 'initial',
          display: 'none',
          '@tablet': { display: 'flex' }
        }}
        onClick={(evt) => {
          evt.stopPropagation()
          segmentTrackRemix('song', song.id, 'details table')
          remixSong(song.id)
        }}
      >
        {status === 'loading' ? (
          <Spinner style={{ marginRight: '4px' }} />
        ) : (
          <PlusIcon style={{ marginRight: '4px' }} />
        )}
        {'Studio'}
      </Button>
      {song && (
        <FavoriteButton
          arpMediaIndex={song.id}
          mediaType={MediaTypes.SONG as MediaTypesType}
          isDisabled={isDisabled}
        />
      )}
      <IconButton
        css={{ opacity: isHovered ? 1 : 0.5, display: 'none', '@bigscreen': { display: 'flex' } }}
        onClick={handleMore}
      >
        <DotsVertical />
      </IconButton>
    </>
  )
}

export default observer(ActionsColumn)
